import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { useBrandConfiguration } from '@search/core/brands/context';
import { getQueryString } from '@search/core/helpers/getQueryString';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { isTechnicalUrl } from './isTechnicalUrl';
import { setLocation } from './setLocation';
export const SEO_PATH_PARAM = 'seoPath';
export const useRouter = () => {
    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false);
    const [technicalUrl, searchModel, order, page] = useAppContext((store) => [
        store.appConfig.technicalUrl,
        store.searchModel,
        store.order,
        store.page,
    ]);
    const { defaultOrder } = useBrandConfiguration();
    useEffect(() => {
        if (!searchModel)
            return;
        if (!isReady) {
            setIsReady(true);
            return;
        }
        const queryString = getQueryString({ searchModel, page, order }, defaultOrder);
        if (!isTechnicalUrl(technicalUrl)) {
            // WALDO-2025 major issues with SEO page refiner
            setLocation(`/${technicalUrl}?${queryString}`);
        }
        else {
            navigate(`/${technicalUrl}?${queryString}`);
        }
    }, [searchModel, order, page]);
};
